import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';
import type { StylesMap } from 'Types';

let baseStyles: StylesMap = {
    container: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 255, 0, 0.7)',
        flex: 1,
        alignSelf: 'stretch',
        width: '100%',
        height: '100%'
    },
    iconClose: {
        position: 'absolute',
        top: '3%',
        right: '3%'
    },
    displayNone: { display: 'none', width: 0, height: 0, opacity: 0 },
    display: { zIndex: 999 }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            position: 'absolute',
            borderRadius: 5,
            borderWidth: 1,
            borderColor: Theme.secondaryButtonBorderColor,
            backgroundColor: Theme.primaryBackgroundColor
        }
    };
}

export default StyleSheet.create(baseStyles as any);
